import { PrivateLinkProduct } from '../types/PrivateLink';

const pathnameRegex = /\/private\/(.+)/i;

export function extractSlugFromPathname(pathname: string): string {
  const matches = pathname.match(pathnameRegex);

  if (!matches || matches.length !== 2) return '';

  return matches[1];
}

export function productCTAState(product: PrivateLinkProduct) {
  if (product.isEnquiry && product.availableForSale) return 'ENQUIRY';
  if (product.availableForSale) return 'AVAILABLE';
  return 'SOLD_OUT';
}
